
/*
  UXS INTERFACE POLISH V5
  - Este es tu sonido
  - Controles circulares
  - Animación de respuestas
  - Volver a grabar
  - Reloj de 45 segundos

  No toca el visualizador ni el vocoder.
*/

(function () {
  "use strict";

  function init() {
    const root = document.getElementById("uxs-experience");
    const main = document.getElementById("uxs-main");
    const recording = document.getElementById("uxs-recording");
    const record = document.getElementById("uxs-record");
    const answers = document.getElementById("uxs-answer-container");
    const results = document.getElementById("uxs-results");

    if (!root || !main || !recording || !record || !results) {
      return;
    }

    if (root.dataset.interfacePolishReady) return;
    root.dataset.interfacePolishReady = "v5";

    const reduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const sleep = ms =>
      new Promise(resolve => setTimeout(resolve, ms));

    // ESTILOS
    const css = document.createElement("style");
    css.id = "uxs-interface-polish-styles";

    css.textContent = `
      #uxs-answer-container {
        width: min(90vw,420px);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
      }

      #uxs-answer-container .uxs-answer {
        width: 100%;
        min-height: 52px;
        border-radius: 999px !important;
        padding: 14px 24px;
        border: 1px solid rgba(255,255,255,.36);
        background: transparent;
        color: white;
        font: 12px/1.6 monospace;
        letter-spacing: 1.3px;
        cursor: pointer;
        opacity: 1;
        transform: translateY(0);
        transition:
          opacity .7s ease,
          transform .9s cubic-bezier(.22,.7,.24,1),
          background .3s,
          border-color .3s !important;
      }

      #uxs-answer-container .uxs-answer:hover {
        border-color: white;
        background: rgba(255,255,255,.07);
      }

      #uxs-answer-container .uxs-answer.uxs-ui-rejected {
        opacity: 0 !important;
        transform: translateY(12px) scale(.97) !important;
        animation: none !important;
        pointer-events: none;
      }

      #uxs-answer-container .uxs-answer.uxs-ui-selected {
        opacity: 1 !important;
        border-color: white !important;
        background: rgba(255,255,255,.10) !important;
        animation: none !important;
      }

      #uxs-answer-container .uxs-answer.uxs-ui-exit {
        opacity: 0 !important;
        transform: translateY(-42px) scale(.93) !important;
        animation: none !important;
      }

      #uxs-record {
        border-radius: 999px !important;
      }

      /* Pregunta discreta al grabar y recordatorio después */
      #uxs-recording-question {
        display: none;
        max-width: min(86vw, 400px);
        margin: 0 auto 16px;
        color: rgba(255,255,255,.67);
        font: 11px/1.8 monospace;
        letter-spacing: .5px;
        text-align: center;
        white-space: normal;
      }

      #uxs-recording-question.uxs-visible {
        display: block;
      }

      #uxs-your-question {
        display: none;
        max-width: 360px;
        margin: 0 auto 7px;
        text-align: center;
      }

      #uxs-your-question.uxs-visible {
        display: block;
      }

      .uxs-your-question-label {
        margin-bottom: 8px;
        color: rgba(255,255,255,.46);
        font: 9px/1.5 monospace;
        letter-spacing: 2px;
      }

      .uxs-your-question-text {
        color: rgba(255,255,255,.78);
        font: 11px/1.8 monospace;
        letter-spacing: .5px;
        overflow-wrap: anywhere;
      }

      #uxs-record-timer {
        display: none;
        color: rgba(255,255,255,.55);
        font: 11px monospace;
        letter-spacing: 2px;
        font-variant-numeric: tabular-nums;
        text-align: center;
      }

      #uxs-results,
      #uxs-results audio {
        display: none !important;
      }

      #uxs-audio-interface {
        display: none;
        width: min(90vw,410px);
        margin: 18px auto 0;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        text-align: center;
        font-family: monospace;
      }

      #uxs-audio-interface.uxs-visible {
        display: flex !important;
        animation: uxs-sound-enter .8s ease both;
      }

      .uxs-sound-title {
        color: white;
        font: 400 clamp(14px,2vw,18px)/1.6 monospace;
        letter-spacing: 2.2px;
      }

      .uxs-sound-description {
        color: rgba(255,255,255,.53);
        font: 10px/1.8 monospace;
        letter-spacing: 1px;
      }

      .uxs-sound-controls {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: clamp(15px,6vw,48px);
        width: 100%;
        margin: 8px auto;
      }

      .uxs-sound-control {
        appearance: none !important;
        background: none !important;
        border: 0 !important;
        box-shadow: none !important;
        color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        gap: 11px;
        flex: 0 0 120px;
        width: 120px;
        padding: 0 !important;
        margin: 0 !important;
        cursor: pointer;
        font-family: monospace;
      }

      .uxs-sound-control::before,
      .uxs-sound-control::after {
        content: none !important;
        display: none !important;
      }

      .uxs-sound-circle {
        display: grid;
        place-items: center;
        flex: 0 0 64px;
        width: 64px;
        height: 64px;
        border: 1px solid rgba(255,255,255,.55);
        border-radius: 50%;
        background: rgba(255,255,255,.02);
        box-sizing: border-box;
        transition:
          transform .65s cubic-bezier(.22,.7,.24,1),
          opacity .5s,
          border-color .3s,
          background .3s;
      }

      .uxs-sound-symbol {
        display: grid;
        place-items: center;
        width: 24px;
        height: 24px;
        line-height: 0;
      }

      .uxs-sound-symbol svg {
        display: block;
        width: 22px;
        height: 22px;
        fill: currentColor;
      }

      .uxs-sound-control:hover .uxs-sound-circle,
      .uxs-sound-control:focus-visible .uxs-sound-circle {
        transform: scale(1.07);
        border-color: white;
        background: rgba(255,255,255,.08);
      }

      .uxs-sound-control.uxs-clicked .uxs-sound-circle {
        transform: scale(.86);
        opacity: .45;
      }

      .uxs-sound-control.uxs-playing .uxs-sound-circle {
        background: rgba(255,255,255,.12);
        border-color: white;
      }

      .uxs-sound-label {
        width: 120px;
        max-width: 100%;
        color: rgba(255,255,255,.82);
        font: 10px/1.6 monospace;
        letter-spacing: 1px;
        text-align: center;
      }

      .uxs-sound-control.uxs-secondary {
        opacity: .65;
      }

      .uxs-sound-control.uxs-secondary:hover,
      .uxs-sound-control.uxs-secondary.uxs-playing {
        opacity: 1;
      }

      #uxs-record-again {
        appearance: none;
        align-self: center;
        margin: 10px auto 0;
        padding: 13px 26px;
        color: rgba(255,255,255,.8);
        background: transparent;
        border: 1px solid rgba(255,255,255,.4);
        border-radius: 999px;
        font: 10px monospace;
        letter-spacing: 1.5px;
        cursor: pointer;
        transition:
          opacity .45s,
          transform .65s,
          border-color .3s;
      }

      #uxs-record-again:hover {
        color: white;
        border-color: white;
        background: rgba(255,255,255,.06);
        transform: translateY(-3px);
      }

      #uxs-record-again:active {
        opacity: .4;
        transform: scale(.94);
      }

      .uxs-sound-privacy {
        max-width: 360px;
        margin: 7px auto 0;
        color: rgba(255,255,255,.48);
        font: 10px/1.9 monospace;
        letter-spacing: .7px;
        text-align: center;
      }

      @keyframes uxs-sound-enter {
        from {
          opacity: 0;
          transform: translateY(14px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @media (max-width: 440px) {
        .uxs-sound-controls { gap: 13px; }

        .uxs-sound-control {
          width: 112px;
          flex-basis: 112px;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        #uxs-answer-container .uxs-answer,
        .uxs-sound-circle {
          transition-duration: .1s !important;
        }

        #uxs-audio-interface.uxs-visible {
          animation: none !important;
        }
      }
    `;

    document.getElementById(css.id)?.remove();
    document.head.appendChild(css);

    // ANIMAR RESPUESTAS ANTES DE AVANZAR
    if (answers) {
      let animating = false;
      let forwarding = false;

      answers.addEventListener("click", async event => {
        if (forwarding) return;

        const selected =
          event.target.closest(".uxs-answer");

        if (!selected || !answers.contains(selected)) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        if (animating || selected.disabled) return;

        animating = true;

        answers.querySelectorAll(".uxs-answer")
          .forEach(button => {
            button.classList.add(
              button === selected
                ? "uxs-ui-selected"
                : "uxs-ui-rejected"
            );
          });

        await sleep(reduced ? 80 : 500);

        if (!selected.isConnected) {
          animating = false;
          return;
        }

        selected.classList.add("uxs-ui-exit");

        await sleep(reduced ? 80 : 850);

        if (selected.isConnected) {
          forwarding = true;

          try {
            selected.click();
          } finally {
            forwarding = false;
          }
        }

        animating = false;
      }, true);
    }

    // Conserva la pregunta que la experiencia ya muestra; no altera su lógica.
    // Si el Liquid expone data-uxs-question, se usa como fuente prioritaria.
    const recordQuestion = document.createElement("div");
    recordQuestion.id = "uxs-recording-question";
    recordQuestion.setAttribute("aria-live", "off");
    record.parentNode.insertBefore(recordQuestion, record);

    let currentQuestion = "";

    function readQuestion() {
      const explicit = [
        recording.getAttribute("data-uxs-question"),
        root.getAttribute("data-uxs-question"),
        document.getElementById("uxs-deep-question")?.textContent,
        document.getElementById("uxs-recording-prompt")?.textContent,
        recording.querySelector("[data-uxs-question-text]")?.textContent,
        recording.querySelector(".uxs-recording-question, .uxs-deep-question, .uxs-question-text")?.textContent
      ];
      const valid = text => {
        const value = (text || "").replace(/\s+/g, " ").trim();
        return value && value.length <= 350 ? value : "";
      };
      const direct = explicit.map(valid).find(Boolean);
      if (direct) return direct;

      // Sólo detectamos texto con interrogación en la pantalla de grabación.
      // No tomamos textos de opciones, botones, ni de la transcripción.
      const candidates = recording.querySelectorAll(
        "h1, h2, h3, h4, p, [class*='prompt'], [class*='question']"
      );
      for (const element of candidates) {
        if (element.closest("button, #uxs-audio-interface, #uxs-recording-question, #uxs-results, #uxs-answer-container")) continue;
        const value = valid(element.textContent);
        if (value && /[¿?]/.test(value)) return value;
      }
      return "";
    }

    function updateQuestionForRecording() {
      currentQuestion = readQuestion() || currentQuestion;
      recordQuestion.textContent = currentQuestion;
      recordQuestion.classList.toggle("uxs-visible", Boolean(currentQuestion));
      document.getElementById("uxs-your-question")?.classList.remove("uxs-visible");
    }

    // RELOJ VISUAL
    // La detención a los 45 s ocurre en el Liquid.
    document.getElementById("uxs-record-timer")?.remove();

    const timer = document.createElement("div");
    timer.id = "uxs-record-timer";
    timer.textContent = "00:00 / 00:45";

    record.insertAdjacentElement("afterend", timer);

    let tick = null;
    let started = 0;

    function stopClock() {
      if (tick !== null) {
        clearInterval(tick);
        tick = null;
      }
      timer.style.display = "none";
    }

    root.addEventListener("uxs:recording-started", () => {
      stopClock();

      updateQuestionForRecording();
      started = performance.now();
      timer.style.display = "block";
      timer.textContent = "00:00 / 00:45";

      tick = setInterval(() => {
        const seconds = Math.min(
          45,
          Math.floor((performance.now() - started) / 1000)
        );

        timer.textContent =
          "00:" +
          String(seconds).padStart(2, "0") +
          " / 00:45";
      }, 250);
    });

    root.addEventListener("uxs:recording-stopped", () => {
      stopClock();
      recordQuestion.classList.remove("uxs-visible");
    });

    // INTERFAZ DE AUDIO
    const old = document.getElementById(
      "uxs-audio-interface"
    );

    if (old) old.remove();

    const ui = document.createElement("div");
    ui.id = "uxs-audio-interface";

    ui.innerHTML = `
      <div id="uxs-your-question">
        <div class="uxs-your-question-label">TU PREGUNTA</div>
        <div class="uxs-your-question-text"></div>
      </div>

      <div class="uxs-sound-title">
        ESTE ES TU SONIDO.
      </div>

      <div class="uxs-sound-description">
        ESCUCHA CÓMO SUENA TU SEÑAL.
      </div>

      <div class="uxs-sound-controls">

        <button
          type="button"
          class="uxs-sound-control"
          id="uxs-sound-transformed"
          aria-label="Escuchar señal transformada"
        >
          <span class="uxs-sound-circle">
            <span class="uxs-sound-symbol"></span>
          </span>
          <span class="uxs-sound-label">
            TU SEÑAL
          </span>
        </button>

        <button
          type="button"
          class="uxs-sound-control uxs-secondary"
          id="uxs-sound-original"
          aria-label="Escuchar voz original"
        >
          <span class="uxs-sound-circle">
            <span class="uxs-sound-symbol"></span>
          </span>
          <span class="uxs-sound-label">
            VOZ ORIGINAL
          </span>
        </button>
      </div>

      <button
        type="button"
        id="uxs-record-again"
      >
        VOLVER A GRABAR
      </button>

      <div class="uxs-sound-privacy">
        TU VOZ FUE TRANSFORMADA.
        NO SE COMPARTE CON OTRAS PERSONAS
        SIN TU AUTORIZACIÓN.
      </div>
    `;

    recording.appendChild(ui);

    const bSignal = ui.querySelector(
      "#uxs-sound-transformed"
    );

    const bOriginal = ui.querySelector(
      "#uxs-sound-original"
    );

    const bAgain = ui.querySelector(
      "#uxs-record-again"
    );

    const original = () =>
      document.getElementById("uxs-playback");

    const transformed = () =>
      document.getElementById("uxs-vocoder-player");

    const hasSrc = audio => Boolean(
      audio &&
      (
        audio.getAttribute("src") ||
        audio.querySelector("source[src]")
      )
    );

    const PLAY = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M9 6.5L17.5 12L9 17.5Z"/>
      </svg>
    `;

    const PAUSE = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="7" y="6" width="3.4"
          height="12" rx=".6"/>
        <rect x="13.6" y="6" width="3.4"
          height="12" rx=".6"/>
      </svg>
    `;

    function updateButton(button, audio) {
      const playing = Boolean(
        audio && !audio.paused && !audio.ended
      );

      button.classList.toggle("uxs-playing", playing);

      const icon = button.querySelector(
        ".uxs-sound-symbol"
      );

      const mode = playing ? "pause" : "play";

      if (icon.dataset.mode !== mode) {
        icon.dataset.mode = mode;
        icon.innerHTML = playing ? PAUSE : PLAY;
      }

      button.setAttribute(
        "aria-label",
        playing ? "Pausar audio" : "Reproducir audio"
      );
    }

    function updateUI() {
      const ready =
        !results.hidden &&
        (
          hasSrc(original()) ||
          hasSrc(transformed())
        );

      ui.classList.toggle("uxs-visible", ready);
      const questionPanel = ui.querySelector("#uxs-your-question");
      questionPanel.querySelector(".uxs-your-question-text").textContent = currentQuestion;
      questionPanel.classList.toggle("uxs-visible", ready && Boolean(currentQuestion));

      root.classList.toggle(
        "uxs-has-custom-audio",
        ready
      );

      bOriginal.style.display =
        hasSrc(original()) ? "flex" : "none";

      bSignal.style.display =
        hasSrc(transformed()) ? "flex" : "none";

      updateButton(bOriginal, original());
      updateButton(bSignal, transformed());
    }

    let pending = false;

    function scheduleUI() {
      if (pending) return;

      pending = true;

      requestAnimationFrame(() => {
        pending = false;
        updateUI();
      });
    }

    async function toggleAudio(button, target, other) {
      const audio = target();
      const otherAudio = other();

      if (!hasSrc(audio)) return;

      button.classList.add("uxs-clicked");

      setTimeout(() => {
        button.classList.remove("uxs-clicked");
      }, reduced ? 100 : 380);

      if (otherAudio && !otherAudio.paused) {
        otherAudio.pause();
      }

      if (audio.paused) {
        try {
          await audio.play();
        } catch (error) {
          console.warn("UXS playback:", error);
        }
      } else {
        audio.pause();
      }

      scheduleUI();
    }

    bSignal.addEventListener("click", () => {
      toggleAudio(
        bSignal,
        transformed,
        original
      );
    });

    bOriginal.addEventListener("click", () => {
      toggleAudio(
        bOriginal,
        original,
        transformed
      );
    });

    // VOLVER A GRABAR
    bAgain.addEventListener("click", () => {
      if (bAgain.disabled) return;

      bAgain.disabled = true;

      original()?.pause();
      transformed()?.pause();

      ui.classList.remove("uxs-visible");
      recordQuestion.classList.remove("uxs-visible");
      currentQuestion = "";
      results.hidden = true;

      root.classList.remove(
        "uxs-audio-ready",
        "uxs-has-custom-audio"
      );

      record.disabled = false;
      record.textContent = "GRABAR DE NUEVO";

      // Reutiliza el mismo grabador.
      // No repite la transición del ente.
      record.click();

      bAgain.disabled = false;
    });

    new MutationObserver(scheduleUI).observe(
      results,
      {
        attributes: true,
        attributeFilter: ["hidden"],
        childList: true,
        subtree: true
      }
    );

    root.addEventListener("uxs:audio-ready", scheduleUI);
    root.addEventListener("uxs:audio-cleared", () => {
      stopClock();
      scheduleUI();
    });

    ["play", "pause", "ended"].forEach(name => {
      main.addEventListener(name, event => {
        if (event.target instanceof HTMLMediaElement) {
          scheduleUI();
        }
      }, true);
    });

    updateUI();

    console.log("UXS Interface Polish V5 Ready");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
